// uiPromptBox
  // Handles all promptBoxes
App.uiPromptBox = {
  opts: {
    easing: 'easeInOutExpo',
    speed: 450
  },

  // constructor
  initialize: function() {
    var $prompts = $('.uiPromptBox');

    if ( $prompts.length ) {
      $prompts.each( _.bind(this._bind, this) );
    }
  },

  // bind events to each instance
  _bind: function(i, el) {
    var self = this,
        $t = $(el),
        prompt = $t.data('prompt') || $t.attr('href'),
        $prompt;

    if ( prompt == null ) return;

    prompt = normalizeSelector(prompt);

    if ( ($prompt = $(prompt)) && $prompt.length == 0 ) return;

    // main events
    $prompt.on('open.uiPromptBox close.uiPromptBox toggle.uiPromptBox', function(e) {
      var active = $prompt.is('.active');

      $prompt
        .toggleClass('active', !active)
        .stop(true, true)
        .slideToggle(self.opts.speed, self.opts.easing);
    });

    $t.on('click.uiPromptBox', function(e) {
      e.preventDefault();

      $prompt.trigger('toggle.uiPromptBox');
    });

    // auto grab cancel elements
    $prompt.find('.uiPromptBox-close').on('click.uiPromptBox', function(e) {
      e.preventDefault();

      $prompt.trigger('close.uiPromptBox');
    });
  }
};
// end uiTip

// btnToggle
  // Toggles a button with class .show or nil
App.btnToggle = {
  opts: {
    onClass: '',
    offClass: 'show'
  },

  // constructor
  initialize: function () {
    var self = this;

    this.$el = $('.btnToggle');

    // tiny module: we'll just do the binding here
    if ( this.$el.length ) {
      this.$el.unbind('click').bind('click', function(e) {
        e.preventDefault();
        $(this).toggleClass( $.trim(self.opts.onClass + ' ' + self.opts.offClass) );
      });
    }
  }
};
// end btnToggle

App.uiWordCount = {
  initialize: function() {
    $('.uiWordCount').textareaCounter();
  }
};

// uiModal
  // Modals can be opened manually by calling App.uiModal.open( $el ) or
  // they can be opened with an anchor (.uiModalLink) with a data-modal=".myModalSelector"
App.uiModal = {
  opts: {
    containerId: null,
    closeHtml: '<a class="modalCloseImg" title="Close"></a>',
    closeClass: 'uiModalClose img-circle',
    dataId: null,
    focus: false,
    overlayClose: true
  },
  initialize: function() {
    var opts;

    $(document).on('click', '.uiModalClose', function(e) {
      $.modal.close();
    });

    this.$el = $('.uiModal');

    if ( !this.$el.length ) return;

    $.extend(this.opts, {
      minHeight: this.$el.data('minheight')
    });

    this.$el.each( _.bind(this._autoOpen, this) );

    this.bindLinks();
  },
  _autoOpen: function(i, el) {
    var $t = $(el);

    if ( $t.data('autoopen') || $t.hasClass('autoopen') )
    {
      this.open( $t );
    }
  },
  bindLinks: function() {
    $('.uiModalLink').each( _.bind(this._handleLinks, this) );

    return this;
  },
  close: function() {
    $.modal.close();
    return this;
  },
  // This is necessary to keep iframes with embeds from floating above modals
  fixFrames: function() {
    $('iframe:visible').addClass('uiModalHiddenFrame').hide();
    return this;
  },
  _handleLinks: function(i, el) {
    var self = this,
        $el = $(el),
        modal = $el.data('modal'),
        $modal;

    if ( !modal ) return;

    $el.on('click.uiModal', function(e) {
      e.preventDefault();

      // find the modal from selector each time; should not be cached
      $modal = $( normalizeSelector(modal) );

      if ( !$modal.length ) return;

      self.open( $modal );
    });
  },
  onClose: function(s) {
    this.restoreFrames();

    $.modal.close();
    $('.uiModal').remove(); // for some reason this gets left behind, so remove manually
  },
  open: function($modal) {
    var opts, classNames;

    classNames = $modal.attr('class') || "";
    classNames = $.trim( classNames.replace('uiModal', '') );
    classNames = classNames.split(" ");
    classNames = _.uniq( _.compact( classNames ) );
    classNames = classNames.join(" ");

    opts = $.extend({}, this.opts, {
      containerId: $modal.attr('id')
    });

    $modal.data('origId', opts.containerId).removeAttr('id');

    opts.onClose = _.bind(this.onClose, this);

    $modal.modal( opts );

    return this.fixFrames();
  },
  restoreFrames: function() {
    $('iframe.uiModalHiddenFrame').removeClass('uiModalHiddenFrame').show();
    return this;
  }
};
// end uiModal


// uiScroll
App.uiScroll = {
  initialize: function() {
    return this;
  }
};
// end uiScroll

// Lesson page preview, remove links
App.lessonPreview = {
	initialize: function(){
		if ( $('.onLessonsPreviewView').length == 0 ) return;
		$('#footerInternal').find('.leftLinks a').removeAttr('href').addClass('inactive').css('color','#9F9F9F').css('cursor','text');
	}
};
// end Lesson page preview

// Lesson review flag scroll, scroll to top of page if flagged
App.flagScroll = {
	initialize: function(){
		if ( $('#flagLesson').length == 0 ) return;
		if ( $('#flagLesson').length == 1 && $('#flagLesson').hasClass('inactive') ) return;

		$('#flagLesson').click(function(){
			$('html, body').animate({ scrollTop: 0 }, 500);
		});
	}
};
// End lesson review flag scroll

// })( window, jQuery );
